import { SvgIcon, SvgIconProps } from '@mui/material';

export const GoogleDriveIcon = (props: SvgIconProps) => (
  <SvgIcon
    id="Capa_1"
    enable-background="new 0 0 511.696 511.696"
    height="512"
    viewBox="0 0 511.696 511.696"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g id="Drive_4_">
        <path
          d="m255.395 161.647-106.199 184.2h-.3l61.5 75-137.999 57.9c-2.701-1.5-4.801-3.6-6-5.7l-64.801-120c-3.3-6.601-.599-11.7.3-14.7l173.701-300c1.199-1.8 2.999-3.6 5.4-5.101h.3l89.099 27.601z"
          fill="#59c36a"
        />
      </g>
      <path
        d="m511.696 345.848-120.3 75-28.5-75-107.5-184.2-74.1-128.402c2.098-1.5 4.799-2.399 7.2-2.399h134.799c3.001.899 9.001.599 12.9 7.5l173.701 300c1.199 2.101 1.8 4.8 1.8 7.501z"
        fill="#ffda2d"
      />
      <path
        d="m336.194 38.348c-3.898-6.901-9.899-6.601-12.9-7.5h-67.899v130.8l107.5 184.2 28.5 75 120.3-75c0-2.701-.601-5.4-1.8-7.5z"
        fill="#fdbf00"
      />
      <path
        d="m511.696 345.848c0 2.699-.601 5.4-1.5 7.2l-64.801 120c-2.401 3.9-8.099 7.8-13.2 7.8h-352.599c-2.401 0-5.101-.901-7.2-2.1l76.5-132.9z"
        fill="#4086f4"
      />
      <path
        d="m255.395 480.848h176.8c5.101 0 10.8-3.9 13.2-7.8l64.801-120c.899-1.8 1.5-4.501 1.5-7.2h-256.3v135z"
        fill="#4175df"
      />
    </g>
  </SvgIcon>
);
